
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import {
  CustomTypographyInputValue,
  TypographyPreset,
  TypographyPresetId
} from "@/types/typography";
import FontFamilyInput from "../FontFamily/FontFamilyInput.vue";
import ButtonBarInput from "../ButtonBarInput/ButtonBarInput.vue";
import UnitInput from "../UnitInput/UnitInput.vue";
import DropdownInput from "../DropdownInput.vue";
import ShadowInput from "../ShadowInput/ShadowInput.vue";
import { globalStore, uiStore } from "@/store/store-accessor";
import lodash from "lodash";
import { CSS_WEIGHTS } from "@/lib/fonts/constants";

@Component({
  components: {
    FontFamilyInput,
    ButtonBarInput,
    UnitInput,
    DropdownInput,
    ShadowInput
  }
})
export default class TypographyPresetChooserInput extends Vue {
  @Prop()
  value!: TypographyPresetId;

  get presetsForDropdown() {
    return this.globalPresets.map(x => ({
      text: x.preset.label,
      value: x.preset.id,
      preset: x.custom
    }));
  }

  get globalPresets(): TypographyPreset[] {
    return globalStore.typographyPresets
      ? globalStore.typographyPresets.filter(p => p.preset.label && p.preset.id)
      : [];
  }

  updatePreset(presetId: TypographyPresetId) {
    this.$emit("input", presetId);
  }

  getItemLabel(title: string, custom: CustomTypographyInputValue) {
    const bp = uiStore.currentBreakpoint.id;
    const typography = custom?.customTypography;
    const advanced = typography?.advanced;

    const fontSize = lodash.get(typography, `fontSize.${bp}.style`) as
      | string
      | null;

    const fontStyle = lodash.get(advanced, `fontStyle.${bp}`);
    const fontWeight = lodash.get(typography, `fontWeight.${bp}`);

    const lineHeight =
      lodash.get(advanced, `lineHeight.${bp}.style`) ||
      lodash.get(typography, `lineHeight.${bp}.style`);

    const fontWeightText = CSS_WEIGHTS.find(
      w => w.value === Number(fontWeight)
    )?.shortText;

    const fontWeightHtml = fontWeightText
      ? `<span style="font-weight: ${fontWeight}; font-style: ${fontStyle}">${fontWeightText}</span>`
      : null;

    const includesFontSize =
      fontSize && title.toLowerCase().includes(fontSize.toLowerCase());
    const includesFontWeight =
      fontWeightText &&
      title.toLowerCase().includes(fontWeightText.toLowerCase());

    const sizeAndLine = fontSize
      ? `${fontSize}${lineHeight ? `/${lineHeight}` : ""}`
      : null;

    const parts = [
      includesFontSize ? null : sizeAndLine,
      fontWeightHtml && !includesFontWeight ? fontWeightHtml : null
    ].filter(Boolean);

    return parts.join(" ");
  }
}
